import { IconButton } from "../IconButton";

export interface GoToTopButtonProps {
  /** Use to display the button after scrolling down a container, and hide it when scrolled to the top */
  isVisible: boolean;
  /** Use to scroll to the top of the container */
  onClick: () => void;
  LinkComponent: React.ElementType;
}

/**
 * This button floats at the bottom right of the screen and is used to navigate to the top of a scrollable container.
 */
export function FloatingGoToTopButton(props: GoToTopButtonProps) {
  const { isVisible, onClick, LinkComponent } = props;

  return (
    <IconButton
      LinkComponent={LinkComponent}
      iconType="arrow-up"
      variant="outlined"
      sx={(theme) => ({
        position: "absolute",
        bottom: theme.spacing(12),
        right: theme.spacing(8),
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0px)" : "translateY(100px)",
        transition: theme.transitions.create(["opacity", "transform"], {
          duration: 300,
          easing: "ease-in-out",
        }),
      })}
      onClick={onClick}
    />
  );
}
